var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55469 17.5C8.70097 17.7533 8.91137 17.9637 9.16472 18.11C9.41808 18.2563 9.70547 18.3333 9.99802 18.3333C10.2906 18.3333 10.578 18.2563 10.8313 18.11C11.0847 17.9637 11.2951 17.7533 11.4414 17.5",
    stroke: "#1956A8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71772 12.772C2.60886 12.8913 2.53702 13.0397 2.51094 13.1991C2.48486 13.3585 2.50566 13.522 2.57081 13.6698C2.63597 13.8176 2.74267 13.9433 2.87794 14.0316C3.0132 14.1198 3.17121 14.1669 3.33272 14.167H16.6661C16.8276 14.1671 16.9856 14.1202 17.1209 14.0321C17.2563 13.944 17.3631 13.8185 17.4285 13.6708C17.4938 13.5231 17.5148 13.3596 17.4889 13.2001C17.4631 13.0407 17.3914 12.8923 17.2827 12.7728C16.1744 11.6303 14.9994 10.4162 14.9994 6.66699C14.9994 5.34091 14.4726 4.06914 13.5349 3.13146C12.5972 2.19378 11.3255 1.66699 9.99939 1.66699C8.67331 1.66699 7.40154 2.19378 6.46386 3.13146C5.52618 4.06914 4.99939 5.34091 4.99939 6.66699C4.99939 10.4162 3.82356 11.6303 2.71772 12.772Z",
    stroke: "#1956A8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell2);
export default __webpack_public_path__ + "static/media/icon_bell2.c1be5a38f3190ae8d6f9706eee6cfda1.svg";
export { ForwardRef as ReactComponent };